import { siteData } from '@/mocks/siteData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-primary-100 text-primary-700 rounded-full text-xs font-label mb-3">
            <i className="ri-flashlight-line"></i>最新快讯
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            实时追踪 · 娱乐圈最新动态
          </h2>
          <p className="text-sm text-foreground-500 max-w-[500px] mx-auto">
            24小时不间断更新，第一时间为你推送娱乐圈最新爆料
          </p>
        </div>

        <div className="max-w-[900px] mx-auto">
          <div className="relative pl-8 md:pl-10 border-l-2 border-background-200">
            {siteData.updates.map((item, idx) => (
              <div
                key={item.id}
                className={`relative pb-10 ${idx === siteData.updates.length - 1 ? 'pb-0' : ''}`}
              >
                <div className="absolute -left-[29px] md:-left-[33px] top-0 w-4 h-4 rounded-full bg-primary-500 ring-4 ring-background-100"></div>

                <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4 mb-2">
                  <span className="shrink-0 text-xs font-label text-foreground-500 bg-background-50 px-2 py-1 rounded whitespace-nowrap">
                    {item.date} {item.time}
                  </span>
                  <span className="shrink-0 text-[10px] font-label px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 whitespace-nowrap">
                    {item.category}
                  </span>
                </div>

                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.summary}
                </p>

                <a
                  href="#cards"
                  className="whitespace-nowrap inline-flex items-center gap-1 mt-3 text-xs text-primary-600 hover:text-primary-700 font-label cursor-pointer"
                >
                  阅读详情
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}